export enum SliderTypes {
	NUMERIC = 'numeric',
	FLAT = 'flat',
	TOOLTIP = 'tooltip',
}
